import React from "react";
import { useEffectOnce } from "@lib-shared/hooks";
import { useUpdatePage } from "core/hooks";
import Notice from "components/notice";

const AccountWaitingApproval = () => {
    const [updateTitle,] = useUpdatePage();

    useEffectOnce(() => updateTitle("DStv account waiting approval"));

    return (
        <Notice>
            <i className="result-icon icon-info"></i>

            <h1>DStv account waiting approval</h1>

            <p>
                An administrator will need to approve your access and permissions to this account.
            </p>
        </Notice>
    );
}

export default AccountWaitingApproval;
